import { tr } from 'mmfintech-commons'
import { useCheckoutPolling } from 'mmfintech-checkout-commons'

import { PreviewPayId } from './PreviewPayId'

import type {
  BaseInstructionsResult,
  FawryPayInstructionsResult,
  FlutterwaveMobileAppInstructionsResult
} from 'mmfintech-checkout-commons/types'

import './previewInstructions.scss'

interface PreviewInstructionsProps {
  sessionId: string
  result: BaseInstructionsResult
}

export const PreviewInstructions = ({ sessionId, result }: PreviewInstructionsProps) => {
  const { paymentMethod } = result || {}

  const { startPolling } = useCheckoutPolling({
    sessionId,
    pollingInterval: 5000,
    maxPollCount: 60
  })

  if (paymentMethod === 'PAY_ID') {
    startPolling()
    return <PreviewPayId result={result} />
  }

  if (paymentMethod === 'FAWRY_PAY') {
    const { instructions } = result as FawryPayInstructionsResult
    return <div className='instructions-container'>{instructions}</div>
  }

  if (paymentMethod === 'M_PESA') {
    startPolling()
    const { phoneNumber } = result as FlutterwaveMobileAppInstructionsResult
    return (
      <div className='instructions-container'>
        {tr(
          'CHECKOUT.INSTRUCTIONS.MPESA',
          'You will receive a prompt on mobile number {{phone_number}} to enter your MPESA service PIN to authorize your payment request.',
          { phone_number: phoneNumber }
        )}
      </div>
    )
  }

  if (paymentMethod === 'MOBILE_MONEY') {
    startPolling()
    const { phoneNumber } = result as FlutterwaveMobileAppInstructionsResult
    return (
      <div className='instructions-container'>
        {tr(
          'CHECKOUT.INSTRUCTIONS.MOBILE_MONEY',
          'You will receive a prompt on mobile number {{phone_number}} to enter your Mobile Money service PIN to authorize your payment request.',
          { phone_number: phoneNumber }
        )}
      </div>
    )
  }

  return null
}
